<template>
  <v-bottom-sheet
    v-if="filtersSorted.length"
    inset
    hide-overlay
    dark
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        fab
        class="filter-menu-button"
        :color="activeFilters.length ? 'primary' : undefined"
        v-bind="attrs"
        v-on="on"
      >
        <filter-icon/>
      </v-btn>
    </template>
    <v-sheet class="text-center">
      <unit-list-filter plain @filtering="$emit('filtering')"/>
    </v-sheet>
  </v-bottom-sheet>
</template>

<script>
import { mapGetters } from 'vuex';
import UnitListFilter from './UnitListFilter.vue';
import FilterIcon from './icons/Filter.vue';

export default {
  name: 'FilterMenuButton',
  components: { UnitListFilter, FilterIcon },
  computed: {
    ...mapGetters('filters', ['activeFilters', 'filtersSorted']),
  },
};
</script>

<style scoped lang="scss">
@import "src/assets/stylesheets/app";
@import "FilterMenuButton";

.filter-menu-button {
  position: fixed;
  left: var(--app-main-padding);
  top: var(--app-main-top);
  transition: transform 0.3s ease;

  @media (max-width: 1500px), (max-height: 920px) {
    transform: scale(0.85);
  }

}

</style>
